(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritual-language-switch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ritual-language-switcher')) {
    class RitualLanguageSwitcher extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.trigger = this.querySelector('[data-rls-trigger]');
        this.panel = this.querySelector('[data-rls-panel]');
        this.closeButton = this.querySelector('[data-rls-close]');
        this.input = this.querySelector('[data-rls-language-input]');
        this.options = [...this.querySelectorAll('[data-rls-language-option]')];
        this.host = this.closest('.ritual-language-switch');
        this.nameMode = this.dataset.nameMode || 'native';
        this.position = this.dataset.position || 'bottom-left';
        this.isOpen = false;

        if (!this.form || !this.trigger || !this.panel || !this.input || !this.host) return;

        this.applyLanguageNames();
        this.reserveStableMobileSpace();

        this.trigger.addEventListener('click', () => this.toggle());
        this.closeButton?.addEventListener('click', () => this.close(true));
        this.options.forEach((option) => option.addEventListener('click', () => this.selectLanguage(option)));

        this._onDocumentPointerDown = (event) => {
          if (this.isOpen && !this.contains(event.target)) this.close(false);
        };
        this._onDocumentKeyDown = (event) => {
          if (this.isOpen && event.key === 'Escape') {
            event.preventDefault();
            this.close(true);
          }
        };
        this._onResize = () => {
          this.reserveStableMobileSpace();
          if (this.isOpen) this.positionPanel();
        };

        document.addEventListener('pointerdown', this._onDocumentPointerDown);
        document.addEventListener('keydown', this._onDocumentKeyDown);
        window.addEventListener('resize', this._onResize, { passive: true });
        window.addEventListener('orientationchange', this._onResize, { passive: true });
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this._onDocumentPointerDown);
        document.removeEventListener('keydown', this._onDocumentKeyDown);
        window.removeEventListener('resize', this._onResize);
        window.removeEventListener('orientationchange', this._onResize);
      }

      reserveStableMobileSpace() {
        const hasFloatingOffer = Boolean(document.querySelector('.ritual-floating-offer-cta'));
        this.host.classList.toggle('has-floating-offer', hasFloatingOffer);
      }

      applyLanguageNames() {
        if (this.nameMode !== 'english' || typeof Intl?.DisplayNames !== 'function') return;
        let displayNames;
        try {
          displayNames = new Intl.DisplayNames(['en'], { type: 'language', fallback: 'none' });
        } catch (error) {
          return;
        }
        this.querySelectorAll('[data-rls-language-name]').forEach((element) => {
          const code = element.dataset.languageCode;
          if (!code) return;
          let englishName = '';
          try {
            englishName = displayNames.of(code) || '';
          } catch (error) {
            englishName = '';
          }
          element.textContent = englishName || element.dataset.primaryName || element.dataset.nativeName || code;
        });
      }

      getViewport() {
        const viewport = window.visualViewport;
        if (viewport) {
          return {
            left: viewport.offsetLeft,
            top: viewport.offsetTop,
            width: viewport.width,
            height: viewport.height,
          };
        }
        return {
          left: 0,
          top: 0,
          width: document.documentElement.clientWidth,
          height: window.innerHeight,
        };
      }

      positionPanel() {
        if (!this.isOpen || this.panel.hidden) return;

        const margin = 8;
        const gap = 8;
        const viewport = this.getViewport();
        const triggerRect = this.trigger.getBoundingClientRect();
        const panelRect = this.panel.getBoundingClientRect();
        const panelWidth = panelRect.width;
        const panelHeight = panelRect.height;
        const viewportRight = viewport.left + viewport.width;
        const viewportBottom = viewport.top + viewport.height;

        let left = this.position.endsWith('right') ? triggerRect.right - panelWidth : triggerRect.left;
        left = Math.max(viewport.left + margin, Math.min(left, viewportRight - panelWidth - margin));

        const spaceAbove = triggerRect.top - viewport.top - gap - margin;
        const spaceBelow = viewportBottom - triggerRect.bottom - gap - margin;
        const preferAbove = this.position.startsWith('bottom');
        const openAbove = preferAbove ? (spaceAbove >= Math.min(panelHeight, spaceBelow) || spaceAbove >= panelHeight) : !(spaceBelow >= Math.min(panelHeight, spaceAbove) || spaceBelow >= panelHeight);

        let top;
        if (openAbove) {
          top = triggerRect.top - panelHeight - gap;
        } else {
          top = triggerRect.bottom + gap;
        }

        top = Math.max(viewport.top + margin, Math.min(top, viewportBottom - panelHeight - margin));

        this.panel.style.left = `${Math.round(left)}px`;
        this.panel.style.top = `${Math.round(top)}px`;
        this.panel.style.right = 'auto';
        this.panel.style.bottom = 'auto';
      }

      toggle() {
        this.isOpen ? this.close(false) : this.open();
      }

      open() {
        if (this.isOpen) return;
        this.isOpen = true;
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');

        requestAnimationFrame(() => {
          this.positionPanel();
          const active = this.options.find((option) => option.dataset.current === 'true') || this.options[0];
          active?.focus({ preventScroll: true });
        });
      }

      close(restoreFocus = false) {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.panel.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.trigger.focus({ preventScroll: true });
      }

      selectLanguage(option) {
        const value = option.dataset.languageValue;
        if (!value) return;
        if (value === this.input.value) {
          this.close(true);
          return;
        }
        this.input.value = value;
        this.setAttribute('aria-busy', 'true');
        if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
        else this.form.submit();
      }
    }

    customElements.define('ritual-language-switcher', RitualLanguageSwitcher);
  }

  } catch(e) { console.error(e); }
})();
})();
